
<div class="content-wrapper d-print-none">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Movement Requests</h4>
            <div style="background: #ECECEC;padding:30px;">
                <div nz-row [nzGutter]="8">
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Destination Location">
                           <!-- Department  -->
                            <select class="form-control" required [(ngModel)]="selectedDestinationLocationId" name="selectedDepartmentId"
                              id="selectedDepartmentId"   (change)="onEmpDestinationLocationChange($event)">
                              <option value="">-- Select Destination Location --</option>
                              <option [value]="location.name" *ngFor="let location of Locations">{{location.name}}
                              </option>
                            </select>
                       
                    </nz-card>
                  </div>

                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Initial Location">
                           <!-- Department  -->
                            <select class="form-control" required [(ngModel)]="selectedInitialLocationId" name="selectedLocationId"
                              id="selectedLocationId"   (change)="onEmpInitialLocationChange($event)">
                              <option value="">-- Select Initial Location --</option>
                              <option [value]="location.name" *ngFor="let location of Locations">{{location.name}}
                              </option>
                            </select>
                       
                    </nz-card>
                  </div>

                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Destination Function">
                           <!-- Department  -->
                            <select class="form-control" required [(ngModel)]="selectedDestinationFunctionId" name="selectedDepartmentId"
                              id="selectedDepartmentId"   (change)="onEmpDestinationFunctionChange($event)">
                              <option value="">-- Select Destination Function --</option>
                              <option [value]="department.name" *ngFor="let department of Departments">{{department.name}}
                              </option>
                            </select>
                       
                    </nz-card>
                  </div>

               
                </div>

                <div nz-row [nzGutter]="8">
              
                
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Current Function">
                           <!-- Department  -->
                            <select class="form-control" required [(ngModel)]="selectedCurrentFunctionId" name="selectedDepartmentId"
                              id="selectedDepartmentId"   (change)="onEmpCurrentFunctionChange($event)">
                              <option value="">-- Select Current Function --</option>
                              <option [value]="department.name" *ngFor="let department of Departments">{{department.name}}
                              </option>
                            </select>
                       
                    </nz-card>
                  </div>
                 
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Created Date">
                      <nz-range-picker [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-range-picker>
                      <br>
                      <br> 
                      
                        <button type="button" class="btn btn-primary btn-sm" (click)="GetByDate()">Submit</button>
                    
                   
                    </nz-card>
                  </div>
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Status">
                          <!-- Statuses  -->
                          <select class="form-control" required [(ngModel)]="selectedStatus" name="selectedStatus"
                          id="selectedStatus"   (change)="onStatusChange($event)">
                          <option value="">-- Select Status --</option>
                          <option [value]="status.value" *ngFor="let status of Statuses">{{status.name}}
                          </option>
                        </select>
                    </nz-card>
                  </div>
                
                </div>
              </div>

            <div class="table-responsive pt-3">
               
                    <input type="button" value="Export To Excel" (click)="exportExcel()" class="btn-primary"/>
             
                
                <br>
              <nz-table #MovementTable [nzData]="Requests" [nzPageSize]="50">
                <thead>
  
                  <tr>
                    <th>
                      #
                    </th>
                    <th>
                        Reference
                      </th>
                      <th>
                        Request Date
                      </th>
                      <th>
                       Designation
                      </th>
                      <th>
                        Created By
                      </th>
                      <th>
                        Function
                      </th>
                      <th>
                        Location
                      </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of MovementTable.data; let i = index ;" (click)="open(data)" class="clickable">
  
                    <td>
                      {{i+1}}
                    </td>
                 
                    <td>{{data.reference}}</td>

                    <td>{{data.createdDate | date: 'dd MMMM yyyy'}}</td>
  
                    <td>{{data.employeeDesignation}}</td>
  
                    <td>{{data.createdBy}}</td>
  
                    <td>{{data.employeeUnit}}</td>
  
                    <td>{{data.employeeCurrentLocation}}</td>
                    <td>
                      <button [ngClass]="getStatusColor(data.status)"> {{data.status}}</button>
                    </td>
                  </tr>
                </tbody>
              </nz-table>
  
            </div>
          </div>
        </div>
      </div>
  
  
    </div>
  </div>

  
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040"
[nzVisible]="ViewRequestVisible" [nzFooter]="footerTpl" (nzOnClose)="close()">

<!-- Side swipe content -->
<div class="row d-print-block">
  <div class="col-lg-12 grid-margin stretch-card">
    <div class="card">
      <h5 class="card-title">Movement Request Details</h5>
      <div class="card-body">

        
        <h5>REQUESTOR DETAILS</h5>
        <div class="row">

          <div class="col">
            <label><b>Request Reference</b></label>
            <p>{{ UpdateRequest?.reference }}</p>
          </div>
          <div class="col">
            <label><b>Requester Name</b></label>
            <p>{{ UpdateRequest?.requesterName }}</p>
          </div>
        </div>
        <div class="row">
        
        <div class="col">
          <label><b>Requester Function</b></label>
          <p>{{ UpdateRequest?.requesterFunction }}</p>
        </div>
        <div class="col">
          <label><b>Requester Unit</b></label>
          <p>{{ UpdateRequest?.requesterUnit }}</p>
        </div>
        </div>
        <div class="row">
        
          <div class="col">
            <label><b> Requester Designation</b></label>
            <p>{{ UpdateRequest?.requesterDesignation }}</p>
          </div>
          <div class="col">
            <label><b>Request Date</b></label>
            <p>{{ UpdateRequest?.requestDate | date: 'dd MMMM yyyy'}}</p>
          </div>
          

        
          </div>
      
        <hr>
        
        <h5>Current Employee Data</h5>
        <div class="row">

          <div class="col">
            <label><b>Employee Name</b></label>
            <p>{{ UpdateRequest?.employeeName }}</p>
          </div>
          <div class="col">
            <label><b>Date Assumed Current Role</b></label>
            <p>{{ UpdateRequest?.datAssumeCurrentRole | date: 'dd MMMM yyyy'}}</p>
          </div>

        </div>
        <div class="row">
        
        <div class="col">
          <label><b>Sap Number</b></label>
          <p>{{ UpdateRequest?.employeeSAPNumber }}</p>
        </div>
        <div class="col">
          <label><b>Employee Band</b></label>
          <p>{{ UpdateRequest?.employeeBand }}</p>
        </div>
        </div>

        <div class="row">
        
          <div class="col">
            <label><b>Designation</b></label>
            <p>{{ UpdateRequest?.employeeDesignation }}</p>
          </div>
          <div class="col">
            <label><b>Function</b></label>
            <p>{{ UpdateRequest?.employeeUnit }}</p>
          </div>
          </div>

          <div class="row">
        
            <div class="col">
              <label><b>Unit</b></label>
              <p>{{ UpdateRequest?.employeeUnit }}</p>
            </div>
            <div class="col">
              <label><b>N+1</b></label>
              <p>{{ UpdateRequest?.employeeNPlus1 }}</p>
            </div>
            </div>

            <div class="row">
        
              <div class="col">
                <label><b>Location</b></label>
                <p>{{ UpdateRequest?.employeeCurrentLocation }}</p>
              </div>
              <div class="col">
                <label><b>Last Promotion Date</b></label>
                <p>{{ UpdateRequest?.lastPromotionDate | date: 'dd MMMM yyyy'}}</p>
              </div>
              </div>

            
        <hr>
        <h5>Proposed Employee Data</h5>
        <div class="row">
          <div class="col">
            <label><b>Proposed Designation</b></label>
            <p>{{ UpdateRequest?.proposedDesignation }}</p>
          </div>

          <div class="col">
            <label><b>Proposed N+1</b></label>
            <p>{{ UpdateRequest?.proposedNPlus1 }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <label><b>Proposed Function</b></label>
            <p>{{ UpdateRequest?.proposedFunction }}</p>
          </div>

          <div class="col">
            <label><b>Proposed Unit</b></label>
            <p>{{ UpdateRequest?.proposedUnit }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <label><b>Effective Date</b></label>
            <p>{{ UpdateRequest?.effectiveDate | date: 'dd MMMM yyyy'}}</p>
          </div>

          <div class="col">
            <label><b>Proposed Band</b></label>
            <p>{{ UpdateRequest?.proposedBand }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <label><b>Proposed Cost Center</b></label>
            <p>{{ UpdateRequest?.proposedCostCenter }}</p>
          </div>
          <div class="col">
            <label><b>Proposed Location</b></label>
            <p>{{ UpdateRequest?.proposedLocation }}</p>
          </div>


        </div>

        <hr>
        <h5>Role Details</h5>
        <div class="row">
          <div class="col">
            <label><b>Date Vacancy Occured</b></label>
            <p>{{ UpdateRequest?.dateVacancyOccured | date: 'dd MMMM yyyy'}}</p>
          </div>

          <div class="col">
            <label><b>Reason For Vacancy</b></label>
            <p>{{ UpdateRequest?.reasonForVacancy }}</p>
          </div>

        </div>
          
      <div class="row">
        <div class="col">
          <label><b>Justification For Movement</b></label>
          <p>{{ UpdateRequest?.justificationForVacancy }}</p>
        </div>

        <div class="col">
          <label><b>Type Of Movement</b></label>
          <p>{{ UpdateRequest?.typeOfMovement }}</p>
        </div>

      </div>

      <div class="row">
        <div class="col">
          <label><b>System Requirements For New Role </b></label>
          <p>{{ UpdateRequest?.systemRequirementForNewRole }}</p>
        </div>

      </div>

      <hr>
      <h5>Succession Plan And Transition</h5>
      <div class="row">
        <div class="col">
          <label><b>Job Performance/Performance Review</b></label>
        </div>
<hr>
<hr>
      </div>

      <div class="row">
        <div class="col">
          <label><b>Last Year</b></label>
          <p>{{ UpdateRequest?.performanceLastYear }}</p>
        </div>

        <div class="col">
          <label><b>2 Years</b></label>
          <p>{{ UpdateRequest?.twoYearsPerformance }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label><b>3 Years</b></label>
          <p>{{ UpdateRequest?.threeYearsPerformance }}</p>
        </div>

        <div class="col">
          <label><b>Last Talent Review Grid/Comments</b></label>
          <p>{{ UpdateRequest?.lastTalentReviewComment }}</p>
        </div>
      </div>
       

      

      <div class="row">
        <div class="col">
          <label><b>Succession Plan Ready</b></label>
          <p>{{ UpdateRequest?.successionPlanReady }}</p>
        </div>
        <div class="col">
          <label><b>Development Plan</b></label>
          <p>{{ UpdateRequest?.developmentPlan }}</p>
        </div>

       
      </div>

      <div class="row">
       
        <div class="col">
          <label><b>Identified Gaps</b></label>
          <p>{{ UpdateRequest?.identifiedGaps }}</p>
        </div>
      </div>
      </div>
      <br>
      <hr>
        <div class="row">
          <div class="col">
            <div class="col pull right" >	
              <button (click)="getJD(UpdateRequest)">Download Document</button>
            </div>
            
          </div>

          <div class="col">
            <div class="col pull right" >	
            <nz-space>
               
                <button *nzSpaceItem nz-button nzType="primary" (click)="showDocument(UpdateRequest)">View Document</button>
              </nz-space>
        </div>
      </div>
        </div>

  
    </div>

  </div>
</div>
 <!-- Approvals -->
 <div class="card-body" >
  <h5 class="card-title">Approvals</h5>
  <div class="table-responsive" >
    <table class="table table--striped table-hover">
      <thead>
        <tr>

          <th>
            Designation Name
          </th>

          <th>
            Approved By
          </th>
          <th>
            Date Approved
          </th>
          <th>
            Message
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let approval of RequestApprovals">
          <td>{{approval.designationName}}</td>
          <td>{{approval.approvedBy}}</td>
          <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
          <td>{{approval.message}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!RequestApprovals?.length"
    style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
    <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
  </div>
  <!-- Approvals -->
</div>

</nz-drawer>

<ng-template #footerTpl>
  <div style="float: right" class="d-print-none">
      <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;" (click)="close()">Close</button>
  </div>


</ng-template>
  